import React from "react"

import globalStyles from "../../../../App.module.scss";

export default function Directories() {
    return (<>
            <div className={globalStyles.article}>
                <div>
                    <h1 style={{margin: "1em"}}>Linux directories</h1>
                    <div className={globalStyles.styledTable}>
                        <table style={{minWidth: '330px'}}>
                            <thead>
                            <tr>
                                <th colSpan="2">Basic linux directories explained</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><b>/</b></td>
                                <td>The root of the virtual directory. There are no files here normally.</td>
                            </tr>

                            <tr>
                                <td><b>/bin</b></td>
                                <td>The binary directory</td>
                            </tr>

                            <tr>
                                <td><b>/dev</b></td>
                                <td>The device directory, where all device nodes are created.</td>
                            </tr>

                            <tr>
                                <td><b>/etc</b></td>
                                <td>System configuration files directory.</td>
                            </tr>


                            <tr>
                                <td><b>/home</b></td>
                                <td>Here is where all Linux user directories are created</td>
                            </tr>

                            <tr>
                                <td><b>/lib</b></td>
                                <td>The library directory, where all system application library files are stored.</td>
                            </tr>
                            <tr>
                                <td><b>/media</b></td>
                                <td>A common place for mount points used for removable media.</td>
                            </tr>
                            <tr>
                                <td><b>/mnt</b></td>
                                <td>Similar to media but this directory is used for mount points (/etc/fstab).</td>
                            </tr>
                            <tr>
                                <td><b>/opt</b></td>
                                <td>The optional directory is used for optional software packages.</td>
                            </tr>
                            <tr>
                                <td><b>/root</b></td>
                                <td>The root user's home directory</td>
                            </tr>
                            <tr>
                                <td><b>/sbin</b></td>
                                <td>The system binary directory, where many admin-level utilities are stored.</td>
                            </tr>
                            <tr>
                                <td><b>/tmp</b></td>
                                <td>The temporary directory, for ephemeral storage</td>
                            </tr>
                            <tr>
                                <td><b>/usr</b></td>
                                <td>The user-installed software</td>
                            </tr>
                            <tr>
                                <td><b>/var</b></td>
                                <td>The variable directory, for files that change frequently, like e.g. log files.</td>
                            </tr>
                            <tr>
                                <td><b>/proc</b></td>
                                <td>Virtual file system only available on run time which contains processes and kernel
                                    information.
                                </td>
                            </tr>
                            <tr>
                                <td><b>/run</b></td>
                                <td>Run-time variable ephemeral data.</td>
                            </tr>
                            <tr>
                                <td><b>/srv</b></td>
                                <td>Data served by the system (e.g web server, ftp ...)</td>
                            </tr>
                            <tr>
                                <td><b>/cdrom</b></td>
                                <td>Convenient read-only access to cdrom once mounted.</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}